export default function Copyright() {
    const getYear = () => {
        const date = new Date();
        return date.getFullYear();
    }
    
    return (
        <div className="text-center text-white mt-8">
            <p className="text-lg">© {getYear()} BelleEpoque, Lda. All rights reserved.</p>
        </div>
    );
}
